function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n          .cls-1,.cls-2{fill:currentcolor;}.cls-2{fill-rule:evenodd;}\n      "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 51.34,
  y: 9.45,
  width: 11.93,
  height: 58.39,
  rx: 5.21
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M89.72,50.91c1,4.52,2.41,6.41,5.14,6.41S99,55.54,100,50.91l7.11-36.37c.93-4,1.55-5.09,5.72-5.09h1.74c4.17,0,5,1,3.94,5.09l-7.77,38.23c-1,5.65-3.24,9.73-5.44,11.93s-4.55,3.36-10.46,3.36-8.25-1-10.45-3.24-4.36-6.1-5.44-12L71,14.54c-1-4-.24-5.09,3.94-5.09h1.73c4.17,0,4.81,1,5.73,5.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M134.51,33.31h26V30.45c0-7.54-4.34-11.32-13.12-11.32-8.56,0-12.89,3.78-12.89,11.32Zm36.57,4.35c-.45,4.22-1.56,5.25-5.67,5.25h-30.9v2.52c0,8.34,4.66,11.66,15.89,11.66a60,60,0,0,0,14.45-1.83c3.56-.91,4.56,0,4.56,4v1.49c0,3.77-.67,4.57-4.56,5.6a52.62,52.62,0,0,1-14.45,1.82c-18.67,0-27.34-7.2-27.34-24.45V33.77C123.06,17.19,131.28,9,147.73,9c15.45,0,23.57,8.12,23.57,23.67C171.3,34.34,171.19,35.94,171.08,37.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M29.09,0c3.23,0,6.47-.1,9.7,0,2.51.1,3.6,1.31,3.73,3.85,0,2.79-.07,36.48,0,40.76a29.56,29.56,0,0,1-2,12.25c-2.52,6-7.43,9-13.5,10.31C19,69,11.23,67.32,3.91,63.39A7.09,7.09,0,0,1,0,56.87c0-3.58,3.27-6,6.42-4.29s5.54,3.6,9.11,4.15a19.2,19.2,0,0,0,9.69-.79,8,8,0,0,0,5.52-8.19V13.29c0-1.06-1-1.46-2-1.45-2.76.05-4,.08-6.78.05-3.58,0-4.8-1.26-5-4.8-.06-1.14-.2-2.27-.16-3.41C16.87,1.37,18,.18,20.29.12c2.93-.09,5.87,0,8.8,0Z"
})));

function SvgLogoFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171.3 68.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFill);
export default __webpack_public_path__ + "static/media/logo-fill.6e60e988.svg";
export { ForwardRef as ReactComponent };